import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import NavbarSidebarWrapper from "../../components/navbarSidebarWrapper";
import ScreenLoader from "../../components/ScreenLoader";
import actions from "../../redux/actions";
import { notifyError } from "../../components/ToastContext";

const FantasyJoinedUsers = () => {
  const { matchId } = useParams();
  const data = useSelector((state) => state.fantacyMatch?.liveMatchBook);
  const [loader, setLoader] = useState(true);
  const [teamLoader, setTeamLoader] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [teamDetails, setTeamDetails] = useState([]);
  const [selectedTeamInfo, setSelectedTeamInfo] = useState(null);
  const navigate = useNavigate();

  const fetchData = async () => {
    setLoader(true);
    try {
      let res = await actions.getLiveMatchBook(matchId);
      if (res?.data?.Status === false) {
        notifyError(res?.data?.Result || "Failed to load match book");
      }
    } catch (err) {
      notifyError(err?.response?.data?.Result || "Failed to load match book");
    }
    setLoader(false);
  };

  useEffect(() => {
    fetchData();
  }, [matchId]);

  const handleViewTeam = async (item) => {
    setSelectedTeamInfo(item);
    setShowModal(true);
    setTeamLoader(true);
    setTeamDetails([]);
    try {
      const res = await actions.getUserTeamDetails(item.Teamid, matchId);
      if (res?.data?.Status === false) {
        notifyError(res?.data?.Result || "Failed to load team details");
      } else {
        setTeamDetails(res?.data?.Result || []);
      }
    } catch (err) {
      notifyError(err?.response?.data?.Result || "Failed to load team details");
    }
    setTeamLoader(false);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setTeamDetails([]);
    setSelectedTeamInfo(null);
  };

  const bookList = data?.Result || [];

  return (
    <NavbarSidebarWrapper>
      <div className="d-flex align-items-center mb-2">
        <button
          className="btn btn-sm btn-secondary mr-2"
          onClick={() => navigate("/fantasy-live-match")}
        >
          ← Back
        </button>
        <div className="content-header-btn">
          Joined Users - Match ID: {matchId}
        </div>
      </div>
      {loader ? (
        <ScreenLoader />
      ) : (
        <div className="card shadow mb-4">
          <div className="table-responsive">
            <div
              id="dataTable_wrapper"
              className="dataTables_wrapper dt-bootstrap4"
            >
              <table
                className="table table-bordered table-striped"
                width="100%"
                cellSpacing="0"
              >
                <thead>
                  <tr>
                    <th>#</th>

                    <th>Rank</th>

                    <th>User Name</th>
                    <th>Contest Name</th>
                    <th>Entry Fee</th>
                    <th>Team ID</th>
                    <th>Team Name</th>
                    <th>Contest ID</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {bookList.length > 0 ? (
                    bookList.map((item, index) => (
                      <tr
                        key={`${item.UserId}-${item.ContestId}-${item.Teamid}`}
                        style={{
                          backgroundColor:
                            item.Rank === "1"
                              ? "Yellow"
                              : item.Rank === "2"
                                ? "Silver"
                                : item.Rank === "3"
                                  ? "Saffron"
                                  : "transparent",
                        }}
                      >
                        <td>{index + 1}</td>

                        <td>
                          {["1", "2", "3"].includes(item.Rank) ? item.Rank : ""}
                        </td>
                        <td>{item.UserName || "-"}</td>
                        <td>{item.contest_name}</td>
                        <td>{item.entry_fee}</td>
                        <td>{item.Teamid}</td>
                        <td>{item.TeamName}</td>
                        <td>{item.ContestId}</td>
                        <td>
                          <button
                            className="btn btn-sm btn-info"
                            onClick={() => handleViewTeam(item)}
                          >
                            View Team
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="9" className="text-center">
                        No joined users found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {/* Team Details Modal */}
      {showModal && (
        <div
          className="modal d-block"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  Team Details — User: {selectedTeamInfo?.UserId} | Team:{" "}
                  {selectedTeamInfo?.TeamName} ({selectedTeamInfo?.Teamid})
                </h5>
                <button
                  type="button"
                  className="close"
                  onClick={handleCloseModal}
                >
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                {teamLoader ? (
                  <div className="text-center py-4">Loading...</div>
                ) : teamDetails.length > 0 ? (
                  <table className="table table-bordered table-striped">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Player Name</th>
                        <th>Role</th>
                        <th>Credit</th>
                        <th>Team Role</th>
                        <th>Base Points</th>
                        <th>Final Points</th>
                      </tr>
                    </thead>
                    <tbody>
                      {teamDetails.map((p, i) => (
                        <tr key={p.PlayerId}>
                          <td>{i + 1}</td>
                          <td>{p.PlayerName}</td>
                          <td>{p.role}</td>
                          <td>{p.Credit}</td>
                          <td>
                            <span
                              className={`badge ${
                                p.Role === "Captain"
                                  ? "badge-danger"
                                  : p.Role === "Vice-Captain"
                                    ? "badge-warning"
                                    : "badge-secondary"
                              }`}
                            >
                              {p.Role}
                            </span>
                          </td>
                          <td>{p.BasePoints}</td>
                          <td>{p.FinalPoints}</td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot>
                      <tr style={{ fontWeight: "bold", backgroundColor: "#f8f9fa" }}>
                        <td colSpan="5" className="text-right">Total Points:</td>
                        <td>{teamDetails.reduce((sum, p) => sum + (Number(p.BasePoints) || 0), 0)}</td>
                        <td>{teamDetails.reduce((sum, p) => sum + (Number(p.FinalPoints) || 0), 0)}</td>
                      </tr>
                    </tfoot>
                  </table>
                ) : (
                  <div className="text-center py-4">No team details found</div>
                )}
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={handleCloseModal}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </NavbarSidebarWrapper>
  );
};

export default FantasyJoinedUsers;
